import Base from '../../ts/_base';
import Multi from '../../ts/_multi-inherit';
import A11ys from 'ui-theme/js/a11y';

export default class ManageUserMouse extends Multi(A11ys, Base) {

    navigationKeyCodes = {};

    constructor() {
        super();
    }

    mousemoveHandler() {
        document.body.classList.remove('mouse-user');
    }
}
